import React, { useEffect, useState } from 'react'
import './adminSplashScreen.scss'
import { ReactComponent as HandWaveIcon } from '../../assets/images/HandWaving.svg'
import { Stack, Typography, SvgIcon, Checkbox, Button } from '@mui/material'
import { useGetOrganizationQuery } from '../../shared/queries/useGetOrganizationQuery'
import { getLogInTime } from '../../utilities/adminSplashScreen'

interface AdminSplashScreenProps {
    isVisible: boolean
    onClose: () => void
    getIsRecentlyLoggedIn: () => boolean
}

const AdminSplashScreen: React.FC<AdminSplashScreenProps> = ({ isVisible, onClose, getIsRecentlyLoggedIn }) => {
    const [isChecked, setIsChecked] = useState(false)
    const organizationQuery = useGetOrganizationQuery()

    // if user was recently logged in we show different privacy screen
    const isRecentlyLoggedIn = getIsRecentlyLoggedIn()

    let organizationName = ''

    useEffect(() => {
        const appContent = document.getElementById('blurred-org')
        isChecked ? appContent?.classList.remove('blurred-content') : appContent?.classList.add('blurred-content')
    }, [isChecked])

    const setCheckBox = () => {
        setIsChecked((prev) => !prev)
    }

    // stops showing splash screen when logging out
    // stops from showing wrong splash screen when logging in
    if (!isVisible || !getLogInTime()) return null

    if (!organizationQuery.isLoading && organizationQuery.isFetched) {
        organizationName = organizationQuery.data?.name
    }

    return (
        <>
            {isRecentlyLoggedIn ? (
                <div className="admin-splash-screen">
                    <div className="admin-splash-background"></div>
                    <Stack
                        direction="column"
                        className="admin-new-login-screen-content"
                        sx={{
                            backgroundColor: 'figma.grayscale.contentWrapper',
                            padding: 2,
                        }}
                    >
                        {' '}
                        <Stack
                            direction="row"
                            alignItems="center"
                            gap={1}
                            color="figma.grayscale.textHier1"
                            sx={{ pb: 6 }}
                            mb={1}
                        >
                            <SvgIcon
                                component={HandWaveIcon}
                                inheritViewBox
                                fontSize="small"
                                color="inherit"
                                sx={{ fontSize: '24px' }}
                            />
                            <Typography variant="20x500" color="figma.grayscale.textHier1">
                                Welcome Back
                            </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" gap={1} mb={1}>
                            <Typography className="atlas-privacy-screen-text" color="figma.grayscale.textHier1">
                                ATLAS Privacy Screen
                            </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" gap={1} mb={1}>
                            <Typography color="figma.accentColors.black">
                                This mode shields your screen from prying eyes, keeping your information secure in
                                public or shared spaces.
                            </Typography>
                        </Stack>
                        <Stack
                            direction="row"
                            alignItems="center"
                            gap={1}
                            color="figma.grayscale.textHier1"
                            mb={1}
                            sx={{ marginTop: '100px' }}
                        >
                            <Typography>You are currently logged in into:</Typography>
                            <div id="blurred-org" className="blurred-content">
                                {organizationName}
                            </div>
                        </Stack>
                        <Stack direction="row" justifyContent="space-between" gap={10} color="figma.primary" mb={1}>
                            <div>
                                <Checkbox checked={isChecked} onChange={setCheckBox} />
                                I'm Ready!
                            </div>
                            <Button onClick={onClose} variant="text">
                                ENTER ATLAS
                            </Button>
                        </Stack>
                    </Stack>
                </div>
            ) : (
                <div className="admin-splash-screen" onClick={onClose}>
                    {/* Blurred background */}
                    <div className="admin-splash-background"></div>

                    {/* Non-blurred content */}
                    <div className="admin-splash-content">
                        <Typography>"Take care before you share"</Typography>
                        <div className="click-anywhere">
                            <Typography> Click anywhere to continue </Typography>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default AdminSplashScreen
